<template>
<div>
<v-card v-if="!userObj.profilePicture">
    <v-card-text>
      <v-alert color="warning" class="mt-2 font-weight-bold text-center">
        Please upload your profile picture
        <v-btn x-small color="white" light to="/settings"
          >here</v-btn
        >
      </v-alert>
    </v-card-text>
  </v-card>
  <QuestionnaireLayout>
    <h2 class="white--text">
      Good {{ greeting }}, {{ userObj && userObj.firstName }}!
    </h2>
    <p class="white--text">
      Start your journey with DriverX by clicking the button below
    </p>
    <!-- This Buttton was redirecting to /questionnaire before but according to New Flow That page is useless and that's why redirection is changed -->
    <v-btn x-large rounded to="/student-dashboard" class="mt-2 font-weight-bold">
      Get Started
    </v-btn>
  </QuestionnaireLayout>
</div>
</template>

<script>
import QuestionnaireLayout from '@/components/qauestionnaire/QuestionnaireLayout'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      greeting: null
    }
  },
  computed: mapGetters(['userObj']),
  components: {
    QuestionnaireLayout
  },
  created () {
    const d = new Date()
    const time = d.getHours()

    if (time < 12) {
      this.greeting = 'morning'
    }
    if (time >= 12) {
      this.greeting = 'afternoon'
    }
  }
}
</script>
